import { action, observable } from 'mobx';
import {
  API_CLIENT_LOOKUP,
  API_ACCOUNT_LINK_CLIENT,
  API_ACCOUNT_LINK_REP,
} from 'api/endpoints';
import { RootStore } from 'stores/rootStore';
import { PersonType } from 'enums';

export interface LookupResult {
  searchValue?: string;
  displayValue: string;
  id: string;
}

export interface LookupData {
  limit: number;
  personType: PersonType;
  data: LookupResult[];
}

export class ClientSearchStore {

  rootStore: RootStore;
  accountId = '';
  personType: PersonType;
  representative?: boolean;

  constructor(rootStore: RootStore, accountId: string, personType: PersonType, representative?: boolean) {
    this.rootStore = rootStore;
    this.accountId = accountId;
    this.personType = personType;
    this.representative = representative;
  }

  @observable lookupOptions: LookupResult[] = [];
  @observable searchTooBroad = false;

  @action
  fetchLookupOptions = async (search: string) => {
    const response = await this.rootStore.stores.apiStore.get<LookupData>(
      API_CLIENT_LOOKUP(search, this.personType, (10).toString(), this.representative),
    );
    // too many entries
    if (response?.status === 204) {
      this.searchTooBroad = true;
      this.lookupOptions = [];
    } else if (response?.data) {
      this.searchTooBroad = false;
      this.lookupOptions = response.data.data;
    }
  };

  @action
  clearLookupOptions = () => {
    this.lookupOptions = [];
  };

  @action
  linkClientToAccount = async (representative: boolean, clientId: string, refresh: () => void) => {
    const response = await this.rootStore.stores.apiStore.post(
      representative ? API_ACCOUNT_LINK_REP(this.accountId) : API_ACCOUNT_LINK_CLIENT(this.accountId),
      { id: clientId },
    );
    if (response?.status === 200) {
      await this.rootStore.stores.editAccountStore.fetchBasicData(this.accountId);
      refresh();
      this.lookupOptions = [];
    }
  };


}
